import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { canAccessKonkr } from '../../utils/accessControl';
import AccessGate from '../AccessGate';
import AccessState from '../AccessState';
import usePageAccessRedirect from '../../hooks/usePageAccessRedirect';
import KonkrManagement from './KonkrManagement';

const KonkrSession = ({ kind }) => {
  const { accessIssue, handleAccessError } = usePageAccessRedirect({
    deniedTitle: 'Konkr Access Denied',
    deniedMessage: 'Konkr access is unavailable or has been revoked. Please sign in again or contact an administrator.',
    deniedRedirectTo: '/support/account',
  });
  return accessIssue ? <AccessState {...accessIssue} /> : <KonkrManagement kind={kind} onAccessError={handleAccessError} />;
};
const KonkrRoute = ({ kind }) => {
  const { accessContext } = useAuth();
  const scope = JSON.stringify([localStorage.getItem('token'), accessContext, kind]);
  return <AccessGate canAccess={canAccessKonkr} title="Konkr Role Required"
    message="Only accounts assigned the Konkr User role can manage rewards. Administrator or Support Portal access alone is not sufficient. Sign in again after a role change."
    actionLabel="Go To Account" actionTo="/support/account">
    <KonkrSession key={scope} kind={kind} />
  </AccessGate>;
};
export default KonkrRoute;
